"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b;
var moment = require("moment-timezone");
var lodash_1 = require("lodash");
var unitLog_1 = require("./unitLog");
var Temporality;
(function (Temporality) {
    Temporality["PAST"] = "past";
    Temporality["PRESENT"] = "present";
    Temporality["FUTURE"] = "future";
})(Temporality = exports.Temporality || (exports.Temporality = {}));
var CalendarTimeData = /** @class */ (function () {
    function CalendarTimeData(date, time, meridiem, timeZone, temporality, capitalizeFields) {
        if (capitalizeFields === void 0) { capitalizeFields = {
            date: true,
            meridiem: true,
            timeZone: true
        }; }
        this.date = date;
        this.time = time;
        this.meridiem = meridiem;
        this.timeZone = timeZone;
        this.temporality = temporality;
        this.capitalizeFields = capitalizeFields;
        if (this.capitalizeFields.date) {
            this.date = lodash_1.upperFirst(this.date);
        }
        if (this.capitalizeFields.meridiem) {
            this.meridiem = lodash_1.toUpper(this.meridiem);
        }
        if (this.capitalizeFields.timeZone) {
            this.timeZone = lodash_1.toUpper(this.timeZone);
        }
    }
    /**
     *
     * @param inc Fields to include, all are included by default
     */
    CalendarTimeData.prototype.flatten = function (inc) {
        var _this = this;
        if (inc === void 0) { inc = {
            date: true,
            time: true,
            meridiem: true,
            timeZone: true
        }; }
        var sorter = CalendarTimeData.sortOrder;
        var checkInc = function (key) {
            return lodash_1.isBoolean(inc[key]) && inc[key];
        };
        // capitalize by default, if it is not specified
        var checkCap = function (key) {
            return inc[key] && _this.capitalizeFields[key];
        };
        return Object.keys(inc).filter(function (key) { return checkInc(key); })
            .filter(function (key) { return sorter[key]; })
            .sort(function (a, b) { return sorter[a]() > sorter[b]() ? 1 : -1; })
            .reduce(function (prev, curr) {
            if (curr === 'time' && lodash_1.last(prev) === 'date') {
                return prev.concat([
                    ',',
                    curr
                ]);
            }
            else {
                return prev.concat([curr]);
            }
        }, [])
            .map(function (key) { return !_this[key] ? key :
            checkCap(key) ?
                key === 'date' ?
                    lodash_1.upperFirst(_this[key]) :
                    _this[key].toUpperCase() :
                _this[key].toLowerCase(); })
            .reduce(function (prev, curr) {
            if (curr === ',' || lodash_1.isEmpty(prev)) {
                return prev.concat([curr]);
            }
            else {
                return prev.concat([
                    ' ',
                    curr
                ]);
            }
        }, [])
            .join('');
    };
    CalendarTimeData.prototype.toString = function () {
        return this.flatten();
    };
    CalendarTimeData.sortOrder = (_a = {},
        _a['date'] = function () { return 0; },
        _a['time'] = function () { return 1; },
        _a['meridiem'] = function () { return 2; },
        _a['timeZone'] = function () { return 3; },
        _a);
    return CalendarTimeData;
}());
exports.CalendarTimeData = CalendarTimeData;
var CommonDateFormats;
(function (CommonDateFormats) {
    CommonDateFormats["MONTH_DAY_YEAR"] = "MMMM D YYYY";
    CommonDateFormats["MONTH_DAY_YEAR_SLASHES"] = "M/D/YYYY";
    CommonDateFormats["DAY_MONTH_YEAR"] = "D MMMM YYYY";
    CommonDateFormats["DAY_MONTH_YEAR_SLASHES"] = "D/M/YYYY";
})(CommonDateFormats = exports.CommonDateFormats || (exports.CommonDateFormats = {}));
exports.guessedTimeZone = moment.tz.guess();
var temporalityMapper = (_b = {},
    _b[Temporality.PAST] = function (testDate, today) {
        return testDate.isBefore(today, 'day');
    },
    _b[Temporality.PRESENT] = function (testDate, today) {
        return testDate.isSame(today, 'day');
    },
    _b[Temporality.FUTURE] = function (testDate, today) {
        return testDate.isAfter(today, 'day');
    },
    _b);
exports.determineTemporality = function (date, timeZone) {
    var today = moment().tz(timeZone);
    return lodash_1.keys(temporalityMapper)
        .reduce(function (temporality, tName) {
        return (temporalityMapper[tName](date, today))
            ? tName : temporality;
    }, Temporality.PAST);
};
function convertCalendarTime(calendarTime, args) {
    if (args === void 0) { args = {}; }
    var timeInMillis = calendarTime.timeInMillis, timeZone = calendarTime.timeZone;
    var _a = args.dateFormat, dateFormat = _a === void 0 ? CommonDateFormats.MONTH_DAY_YEAR : _a, _b = args.timeFormat, timeFormat = _b === void 0 ? 'h:mm' : _b, _c = args.meridiemFormat, meridiemFormat = _c === void 0 ? 'a' : _c, _d = args.timeZoneFormat, timeZoneFormat = _d === void 0 ? 'z' : _d, _e = args.capitalize, capitalize = _e === void 0 ? true : _e, _f = args.capitalizeDate, capitalizeDate = _f === void 0 ? capitalize : _f, _g = args.capitalizeMeridiem, capitalizeMeridiem = _g === void 0 ? capitalize : _g, _h = args.capitalizeTimeZone, capitalizeTimeZone = _h === void 0 ? capitalize : _h;
    var tz = timeZone;
    if (lodash_1.isEmpty(tz) || !moment.tz.zone(tz)) {
        unitLog_1.UnitLog.warn("No time zone passed, " +
            ("using guessed time zone: '" + exports.guessedTimeZone + "'."));
        tz = exports.guessedTimeZone;
    }
    var dateTime = moment(timeInMillis).tz(tz);
    return new CalendarTimeData(dateTime.format(dateFormat), dateTime.format(timeFormat), dateTime.format(meridiemFormat), dateTime.format(timeZoneFormat), exports.determineTemporality(dateTime, tz), {
        date: capitalizeDate,
        meridiem: capitalizeMeridiem,
        timeZone: capitalizeTimeZone
    });
}
exports.convertCalendarTime = convertCalendarTime;
//# sourceMappingURL=calendar.js.map